import React from 'react';
import { Result, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RollbackOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

const CardNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100%', 
      minHeight: 300 
    }}>
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的数据不存在。"
        extra={
          <Button 
            type="primary" 
            icon={<RollbackOutlined />}
            onClick={() => navigate('/card-annotation')}
          >
            返回列表
          </Button>
        }
      >
        <div style={{ textAlign: 'center' }}>
          <Paragraph>
            <Text strong>可能的原因：</Text>
          </Paragraph>
          <Paragraph>
            1. 数据已被删除或移动
          </Paragraph>
        </div>
      </Result>
    </div>
  );
};

export default CardNotFound;